import React, { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import AuthenticationContext from "../contexts/auth/Auth.context";
import { FETCH_USER_DATA } from "../contexts/types.js";
import { LOGIN_URL } from "../config/constants";
import Copyright from "../components/Copyight";
import { EmailRegex } from "../utils/regex";
import axios from "axios";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";

// General Styles
const useStyles = makeStyles((theme) => ({
  Logo: {
    fontFamily: "Grand Hotel, cursive",
    margin: "0px 0px 20px 0px",
  },
  paper: {
    marginTop: "50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  image: {
    backgroundSize: "cover",
    backgroundColor: "#fafafa",
    backgroundImage: "url(https://source.unsplash.com/v0_MCllHY9M)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "100vh",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
}));

const Login = () => {
  const { dispatch } = useContext(AuthenticationContext);

  const history = useHistory();
  const classes = useStyles();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formatValidation, setFormatValidation] = useState(false);
  const [authValidation, setAuthValidation] = useState(false);
  const [serverError, setServerError] = useState(false);

  const handleInputChanges = (e) => {
    switch (e.target.name) {
      case "email":
        setEmail(e.target.value);
        break;
      case "password":
        setPassword(e.target.value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = () => {
    if (EmailRegex.test(email)) {
      axios
        .post(LOGIN_URL, { password, email })
        .then((res) => {
          const data = res.data;
          if (data.error) {
            setFormatValidation(false);
            setAuthValidation(true);
          } else {
            localStorage.setItem("jwt", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));
            dispatch({ type: FETCH_USER_DATA, payload: data.user });
            history.push("/");
          }
        })
        .catch((err) => {
          setServerError(true);
        });
    } else {
      setAuthValidation(false);
      setServerError(false);
      setFormatValidation(true);
    }
  };

  return (
    <Grid container>
      {process.env.MODE === "demo" ||
        (true && (
          <Snackbar open={true}>
            <Alert severity="info">
              <AlertTitle>Demo Mode</AlertTitle>
              To test the application, you can use these credentials:
              {process.env.DEMO_CREDENTIALS || "example@example.com/123456789"}
            </Alert>
          </Snackbar>
        ))}
      <Grid item sm={4} md={6} className={classes.image} />
      <Grid item xs={12} sm={8} md={6}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Typography className={classes.Logo} variant="h2" gutterBottom>
              {process.env.REACT_APP_APP_NAME}
            </Typography>
            {formatValidation ? (
              <Alert variant="outlined" severity="error">
                Invalid Email format
              </Alert>
            ) : null}
            {authValidation ? (
              <Alert variant="outlined" severity="error">
                Invalid given Email/Password
              </Alert>
            ) : null}
            {serverError ? (
              <Alert variant="outlined" severity="error">
                An error occured while connecting to servers. Please Try again
                in a amoment.
              </Alert>
            ) : null}
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoFocus
                value={email}
                onChange={handleInputChanges}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={handleInputChanges}
              />

              <Button
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.submit}
                disabled={email !== "" && password !== "" ? false : true}
                onClick={handleSubmit}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link to="/reset" style={{ textDecoration: "none" }}>
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  {"Don't have an account? "}
                  <Link to="/signup" style={{ textDecoration: "none" }}>
                    {"Sign Up"}
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
          <Box mt={12}>
            <Copyright />
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default Login;
